import { rem } from 'polished';
import styled from 'styled-components';
import { getMaxPageWidth } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(25)};
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${rem(16)};
    margin-bottom: ${rem(15)};
`;

export const Description = styled.span`
    line-height: ${rem(28)};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    margin: 0;
`;

export const Group = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    display: block;
    padding-bottom: ${rem(10)};
`;

export const Packages = styled.div``;

export const Package = styled.div`
    display: flex;
    margin-top: ${rem(10)};
`;

export const Name = styled.span`
    display: inline-block;
    margin-left: ${rem(10)};
    font-size: ${({ theme }) => theme.fontSizes.textMedium};
`;
